import React from 'react';
import Agaman2024  from 'views/Agaman2024';
const ExtraCurricularActivitiesPage = () => {
  return <Agaman2024 />;
};

export default ExtraCurricularActivitiesPage;